export const currencyFormat = (number) =>
  number.toLocaleString("es-ES", {
    style: "currency",
    currency: "COP",
  });